import { SplitTypeWrapper } from "../../components/SplitTypeWrapper";
import { getGsap, getScrollTrigger } from "../global/GsapGlobals";
import { DUR, EASE, STAGGER, motionOK } from "../global/MotionTokens";

const SECTION_SELECTOR = '[data-anim="theh-hero-intro"]';
const TITLE_SELECTOR = "[data-theh-hero-title]";
const LEAD_SELECTOR = "[data-theh-hero-lead]";
const MASK_SELECTOR = ".sec-theh-hero__intro-mask";
const MARK_SELECTOR = ".sec-theh-hero__mark";

export class ThehHeroIntroController {
    static init(): void {
        const sections = Array.from(document.querySelectorAll<HTMLElement>(SECTION_SELECTOR));
        if (!sections.length) return;

        sections.forEach((section) => {
            if (section.dataset.thehHeroIntroBound === "1") return;
            section.dataset.thehHeroIntroBound = "1";

            const mask = section.querySelector<HTMLElement>(MASK_SELECTOR);
            const title = section.querySelector<HTMLElement>(TITLE_SELECTOR);
            const lead = section.querySelector<HTMLElement>(LEAD_SELECTOR);
            let mark = section.querySelector<HTMLElement>(MARK_SELECTOR);

            if (!motionOK()) {
                mask?.setAttribute("hidden", "");
                return;
            }

            const gsap = getGsap();
            const ScrollTrigger = getScrollTrigger();
            const chars = title ? SplitTypeWrapper.splitTitle(title).chars : [];
            mark = section.querySelector<HTMLElement>(MARK_SELECTOR);

            section.classList.add("is-theh-hero-intro-ready");

            if (mask) {
                gsap.set(mask, {
                    opacity: 1,
                    "--theh-hero-mask-radius": "0vmax",
                });
            }
            if (title) {
                gsap.set(title, { opacity: 1 });
            }
            if (chars.length) {
                gsap.set(chars, {
                    yPercent: 112,
                    opacity: 0,
                    willChange: "transform, opacity",
                });
            }
            if (mark) {
                gsap.set(mark, {
                    scale: 0.9,
                    opacity: 0,
                    willChange: "transform, opacity",
                });
            }
            if (lead) {
                gsap.set(lead, {
                    y: 26,
                    opacity: 0,
                    willChange: "transform, opacity",
                });
            }

            const timeline = gsap.timeline({
                defaults: {
                    ease: EASE.outExpo,
                },
                onComplete: () => {
                    if (mask) {
                        mask.setAttribute("hidden", "");
                    }
                    if (chars.length) {
                        gsap.set(chars, { willChange: "auto" });
                    }
                    if (mark) {
                        gsap.set(mark, { willChange: "auto" });
                    }
                    if (lead) {
                        gsap.set(lead, { willChange: "auto" });
                    }
                    ScrollTrigger.refresh();
                },
            });

            if (mask) {
                timeline
                    .to(
                        mask,
                        {
                            "--theh-hero-mask-radius": "145vmax",
                            duration: DUR.epic,
                            ease: EASE.inOut,
                        },
                        0,
                    )
                    .to(
                        mask,
                        {
                            opacity: 0,
                            duration: DUR.slow,
                            ease: EASE.outQuart,
                        },
                        DUR.slower,
                    );
            }

            if (mark) {
                timeline.to(
                    mark,
                    {
                        scale: 1,
                        opacity: 1,
                        duration: DUR.slower,
                        ease: EASE.spring,
                    },
                    0.34,
                );
            }

            if (chars.length) {
                timeline.to(
                    chars,
                    {
                        yPercent: 0,
                        opacity: 1,
                        duration: DUR.slower,
                        stagger: STAGGER.fast,
                    },
                    0.42,
                );
            }

            if (lead) {
                timeline.to(
                    lead,
                    {
                        y: 0,
                        opacity: 1,
                        duration: DUR.slower,
                    },
                    0.92,
                );
            }
        });
    }
}
